var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageAboutUsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 325,
    viewBox: "0 0 183 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.709 423.133L79.9729 202.396L243.069 39.3003L203.769 0L0.717407 203.051L300.709 503.044V423.133Z",
    fill: "rgba(249, 249, 250, 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageAboutUsArrow);
export default __webpack_public_path__ + "static/media/homepage-about-us-arrow.e51a64f3acf7d8318aa61bc9ccdba7bf.svg";
export { ForwardRef as ReactComponent };